import {fetchProduct} from '../util/fetch-product';

const selectors = {
  gridSwatchFieldset: '[data-grid-swatch-fieldset]',
  productItem: '[data-grid-item]',
  productInfo: '[data-product-information]',
  productImage: '[data-product-image]',
  swatchButton: '[data-swatch-button]',
};

const classes = {
  visible: 'is-visible',
  stopEvents: 'no-events',
};

const attributes = {
  handle: 'data-swatch-handle',
  label: 'data-swatch-label',
  swatchCount: 'data-swatch-count',
  variantName: 'data-swatch-variant-name',
  variantTitle: 'data-variant-title',
};

class GridSwatch extends HTMLElement {
  constructor() {
    super();

    this.productItemMouseLeaveEvent = () => this.hideVariantImages();
    this.showVariantImageEvent = (swatchButton) => this.showVariantImage(swatchButton);
    this.resizeEvent = () => this.init();
  }

  connectedCallback() {
    this.handle = this.getAttribute(attributes.handle);
    this.productItem = this.closest(selectors.productItem);
    this.productInfo = this.closest(selectors.productInfo);
    this.productImage = this.productItem.querySelector(selectors.productImage);
    this.swatchesStyle = theme.settings.collectionSwatchStyle;
    document.addEventListener('theme:resize:width', this.resizeEvent);

    const label = this.getAttribute(attributes.label).trim().toLowerCase();

    fetchProduct(this.handle).then((product) => {
      this.product = product;
      this.colorOption = product.options.find(function (element) {
        return element.name.toLowerCase() === label || null;
      });

      if (this.colorOption) {
        this.init();
      }
    });
  }

  init() {
    this.swatchCount = this.productInfo.querySelector(`[${attributes.swatchCount}]`);
    this.swatchFieldset = this.productInfo.querySelector(selectors.gridSwatchFieldset);
    this.hideSwatchesTimer = 0;

    if (this.swatchCount.hasAttribute(attributes.swatchCount)) {
      if (this.swatchesStyle == 'text-slider') {
        this.swatchCount.addEventListener('mouseenter', () => {
          if (this.hideSwatchesTimer) clearTimeout(this.hideSwatchesTimer);

          this.productInfo.classList.add(classes.stopEvents);
          this.swatchFieldset.classList.add(classes.visible);
        });

        // Prevent color swatches blinking on mouse move
        this.productInfo.addEventListener('mouseleave', () => {
          this.hideSwatchesTimer = setTimeout(() => {
            this.productInfo.classList.remove(classes.stopEvents);
            this.swatchFieldset.classList.remove(classes.visible);
          }, 100);
        });
      }

      if (this.swatchesStyle == 'slider' || this.swatchesStyle == 'grid' || this.swatchesStyle == 'limited') {
        this.swatchFieldset.classList.add(classes.visible);
      }
    }

    this.bindSwatchButtonEvents();
  }

  bindSwatchButtonEvents() {
    this.querySelectorAll(selectors.swatchButton)?.forEach((swatchButton) => {
      // Show variant image when hover on color swatch
      swatchButton.addEventListener('mouseenter', this.showVariantImageEvent);
    });

    this.productItem.addEventListener('mouseleave', this.productItemMouseLeaveEvent);
  }

  showVariantImage(event) {
    const swatchButton = event.target;
    const variantName = swatchButton.getAttribute(attributes.variantName)?.replaceAll('"', "'");
    const variantImages = this.productImage.querySelectorAll(`[${attributes.variantTitle}]`);
    const variantImageSelected = this.productImage.querySelector(`[${attributes.variantTitle}="${variantName}"]`);

    // Hide all variant images
    variantImages?.forEach((image) => {
      image.classList.remove(classes.visible);
    });

    // Show selected variant image
    variantImageSelected?.classList.add(classes.visible);
  }

  hideVariantImages() {
    // Hide all variant images
    this.productImage.querySelectorAll(`[${attributes.variantTitle}].${classes.visible}`)?.forEach((image) => {
      image.classList.remove(classes.visible);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.resizeEvent);
  }
}

export {GridSwatch};
